export enum PermissionsCatalogueEnum {
  CreateNotifiactions = 1050,
  // PermissionCatalog Pk_Id 2056 ("Resolve Pending Card Load"). Same entry the API gates the
  // two pending-resolve calls with via [PermissionRequired].
  ResolvePendingCardLoad = 2056,
  // PermissionCatalog Pk_Id 10006 ("uClock Group Setup", stream S4). The proxy gates the
  // group catalog with it (TLMDepartment/*, TLMJobCatalog/*); the location Departments tab
  // uses it only to decide whether "Create new department" is offered (FENIKS US-4.101).
  TlmGroupSetup = 10006,
  // PermissionCatalog Pk_Id 10004 ("uClock Reports"). Shows the Reports tab of the uClock page;
  // the proxy gates TLMReport/* with the same entry (FENIKS US-11.1).
  TlmReports = 10004,
  // PermissionCatalog Pk_Id 10003 ("uClock Approvals"). Shows Time Data → Approvals; the proxy gates
  // TLMApproval/* with the same entry. The sub-tab's page object alone is not enough: the role keeps
  // seeing it unless Role Management wrote a restriction for it (T-89), e.g. Owner after db/S9/02.
  TlmApprovals = 10003,
  // PermissionCatalog Pk_Id 10002 ("uClock Setup") and 10007 ("uClock Edit", FENIKS S9 db/S9/01): together
  // they change the location's setup - departments, jobs, the schedule week (draft, copy, clear, generate,
  // publish, unpublish; the week also needs a scope over the whole location, GetWeek.wholeLocation). GSTLMAPI
  // asks the same for every Location write (decision 2026-10-29).
  TlmSetup = 10002,
  TlmEdit = 10007,
  // PermissionCatalog Pk_Id 10008 ("uClock Manage Departments", FENIKS S9 db/S9/01): all departments of a
  // location. Without it a manager sees only the departments assigned to them. It does not open changes
  // of the location's setup any more - that is Setup + Edit (decision 2026-10-29).
  TlmManageDepartments = 10008,
  // Manager Accounts page. The API gates the matching G5ManagerAccount / G5AccountDetails
  // calls with the same entries.
  ViewManagerAccounts = 1038,
  ManageManagerAccounts = 1123,
  ChangeManagerRole = 2060,
  ChangeManagerLocationAccess = 2059,
  TransferOwnership = 2028,
}
